import { useState } from "react";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

//Material UI Icons
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";

// redux
// common components
// import Loader from "../common/Loader";
import ProductInfo from "../common/ProductInfo";

function ProductMetadataProductsListDialog({ productsList = [], coreDataId = null }) {
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
    const [productDetailsDialogueOpen, setProductDetailsDialogueOpen] = useState(false);
    const [selectedProductInfo, setSelectedProductInfo] = useState({});

    //loader variables
    // const [isLoading, setIsLoading] = useState(false);
    // const [loaderMessage, setLoaderMessage] = useState("");

    const handleUploadDialog = () => {
        setUploadDialogOpen(!uploadDialogOpen);
    };

    const handleProductClick = (e, info) => {
        setProductDetailsDialogueOpen(true);
        setSelectedProductInfo(info);
    };

    return (
        <>
            {/* {isLoading && <Loader message={loaderMessage} />} */}
            <Button
                size="small"
                variant="outlined"
                className={coreDataId ? "custom-btn color-blue custom-btn--upload-reset mt-1 mb-1 ms-0 me-0" : "custom-btn custom-btn--upload-reset mt-1 mb-1 ms-0 me-0"}
                // className={"custom-btn custom-btn--upload-reset mt-1 mb-1 ms-0 me-0"}
                onClick={handleUploadDialog}
                style={{
                    margin: 2,
                    width: "100%",
                    height: "28px",
                }}
                // disabled={true}
                disabled={!coreDataId}
                sx={{
                    textAlign: "left",
                    color: coreDataId ? "#1976d2" : "grey",
                }}
            >
                Edit Product Metadata
            </Button>
            <Dialog
                open={uploadDialogOpen}
                maxWidth={"md"}
                sx={{ "& .MuiDialog-paper": { minHeight: 30, maxHeight: 450, paddingBottom: 4 } }}
                fullWidth
            >
                <DialogTitle
                    style={{
                        backgroundColor: "rgb(51, 94, 234,0.1)",
                        color: "rgb(51, 94, 234)",
                        fontSize: 15,
                        textAlign: "right",
                        padding: "10px 12px",
                    }}
                >
                    Edit Product Metadata
                    <ClearIcon
                        style={{ marginLeft: "40%", cursor: "pointer" }}
                        onClick={handleUploadDialog}
                    />
                </DialogTitle>
                <DialogContent>
                    <p
                        style={{
                            color: "rgb(51, 94, 234)",
                            fontSize: 15,
                            textAlign: "center",
                            padding: "10px 12px",
                        }}
                    >
                        The following products are associated with the study you selected.
                        <br />
                        To modify product metadata details, click on Edit icon
                    </p>
                    {productsList &&
                        productsList.map((datum) => (
                            <div
                                className=""
                                key={datum.productCode}
                                style={{
                                    minHeight: 50,
                                    borderRadius: 5,
                                    width: "100%",
                                    padding: "0px 50px 0px 50px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div className="">
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            marginBottom: 0,
                                            marginTop: 15,
                                            position: "relative",
                                            top: "0%",
                                            transform: "translate(0%, 50%)",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {datum.productCode}
                                    </p>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                    }}
                                >
                                    <Button
                                        variant="text"
                                        component="label"
                                        sx={{ height: "100%" }}
                                        onClick={(e) =>
                                            handleProductClick(e, {
                                                coreDataId: coreDataId,
                                                productCode: datum.productCode,
                                                isCompetitor: datum.isCompetitor,
                                            })
                                        }
                                    >
                                        <EditIcon
                                            sx={{ cursor: "pointer", fontWeight: "bold" }}
                                            fontSize="medium"
                                        />
                                    </Button>
                                </div>
                            </div>
                        ))}
                </DialogContent>
            </Dialog>
            {productDetailsDialogueOpen && (
                <ProductInfo
                    settings={{
                        productDetailsDialogueOpen: productDetailsDialogueOpen,
                        setProductDetailsDialogueOpen: setProductDetailsDialogueOpen,
                        isEdit: true,
                    }}
                    info={selectedProductInfo}
                />
            )}
        </>
    );
}

ProductMetadataProductsListDialog.propTypes = {
    productsList: PropTypes.array,
    coreDataId: PropTypes.number,
};

export default ProductMetadataProductsListDialog;
